"use strict";
exports.__esModule = true;
// import { createHash } from 'crypto';
// import { MD5 } from 'crypto-js';
var Crypto = require("crypto-js");
var Secret = /** @class */ (function () {
    function Secret() {
    }
    /**
     * Gateway API Secret
     * @param token 用于auth的接口的token，没有则默认为空串
     * @param goods 系统名
     * @param terrace 平台号
     * @param edition 版本号
     */
    Secret.prototype.getGatewayAPISecretKey = function (goods, terrace, edition, token) {
        if (token === void 0) { token = ''; }
        return this.md5(goods + terrace + edition + token);
    };
    Secret.prototype.getSign = function (params, secretKey) {
        var sortedParams = this.sortObjectByKey(params);
        var concatStr = this.concatParams(sortedParams);
        concatStr = concatStr + secretKey;
        return this.md5(concatStr);
    };
    /**
     * 排序参数
     * @param params
     */
    Secret.prototype.sortObjectByKey = function (params) {
        var sortedObject = {};
        var sortedKeys = Object.keys(params).sort();
        for (var _i = 0, sortedKeys_1 = sortedKeys; _i < sortedKeys_1.length; _i++) {
            var key = sortedKeys_1[_i];
            sortedObject[key] = params[key];
        }
        return sortedObject;
    };
    /**
     * 拼接参数
     * @param params
     */
    Secret.prototype.concatParams = function (params) {
        var concatStr = '';
        for (var key in params) {
            if (params.hasOwnProperty(key)) {
                var element = params[key];
                if (element instanceof Array) {
                    concatStr += JSON.stringify(element);
                }
                else {
                    concatStr += element;
                }
            }
        }
        return concatStr;
    };
    /**
     * MD5
     * @param args 需要MD5的参数
     */
    Secret.prototype.md5 = function (args) {
        return Crypto.MD5(args.trim())
            .toString()
            .toLocaleLowerCase();
        /* return createHash('md5')
          .update(args.trim())
          .digest('hex')
          .toLowerCase(); */
    };
    return Secret;
}());
exports.Secret = Secret;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./node_modules/xbed-api/lib/utils/secret.js
// module id = 174
// module chunks = 44